import { GetInferredFromRaw } from '@thinknimble/tn-models'
import { z } from 'zod'
import { baseModelShape } from '../base-model'

export const accountTypeEnum = {
  SAVINGS: 'savings',
  CHECKING: 'checking',
} as const

export type AccountTypeValues = (typeof accountTypeEnum)[keyof typeof accountTypeEnum]

export const accountTypeLabelMap = {
  [accountTypeEnum.SAVINGS]: 'Savings',
  [accountTypeEnum.CHECKING]: 'Checking',
}

export const vendorBankAccountShape = {
  ...baseModelShape,
  label: z.string(),
  country: z.string(),
  bankName: z.string(),
  bankCode: z.string().optional().nullable(),
  accountType: z.enum(accountTypeEnum),
  swiftBic: z.string().optional().nullable(),
  iban: z.string().optional().nullable(),
  currencyCode: z.string(),
  isPrimary: z.boolean(),
  isActive: z.boolean(),
  notes: z.string().optional().nullable(),
  maskedAccountNumber: z.string(),
}

export const createVendorBankAccountShape = {
  label: vendorBankAccountShape.label,
  country: vendorBankAccountShape.country,
  bankName: vendorBankAccountShape.bankName,
  bankCode: vendorBankAccountShape.bankCode,
  accountNumber: z.string(),
  accountType: vendorBankAccountShape.accountType,
  swiftBic: vendorBankAccountShape.swiftBic,
  iban: vendorBankAccountShape.iban,
  currencyCode: vendorBankAccountShape.currencyCode,
  isPrimary: z.boolean().optional(),
  isActive: z.boolean().optional(),
  notes: vendorBankAccountShape.notes,
}

export const vendorBankAccountFilterShape = {
  isActive: z.boolean(),
  country: z.string(),
}

export type VendorBankAccount = GetInferredFromRaw<typeof vendorBankAccountShape>
export type CreateVendorBankAccount = GetInferredFromRaw<typeof createVendorBankAccountShape>
export type VendorBankAccountFilter = GetInferredFromRaw<typeof vendorBankAccountFilterShape>
